import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

const ColumnDescrition = ({ description, setDescription, columns, setColumns }) => {
  const impact_indicators = useSelector((state) => (state.analysis.impact_indicators ? state.analysis.impact_indicators : null));

  // const [description_int, set_description_int] = useState(description);

  // useEffect(() => {}, []);

  // const checkIsIndicator = () => {
  //   return;
  // };

  return (
    <>
      <div className="fixed right-0 top-[70px] bg-white h-[750px] w-[660px] border-[#F3F5F7] border-[0.1px]">
        {/* HEADER */}

        {(() => {
          switch (description) {
            case "quantity":
              return (
                <>
                  <div className="h-[70px] w-[600px] mx-[30px] border-[#F3F5F7] border-b-[1px] flex justify-between items-center">
                    <div className="h-[70px] w-[400px] flex items-center justify-start font-Poppins-SemiBold text-lg">Quantité</div>
                    <button
                      className="flex justify-between w-[100px]"
                      onClick={() => {
                        setDescription(0);
                      }}
                    >
                      <p className="text-gray-400 font-Poppins-SemiBold">Retour</p>
                      <BackArrow transform="rotate(180)" />
                    </button>
                  </div>

                  <div className="w-[600px] mx-[30px] my-[10px]">
                    <p className="font-Poppins-SemiBold">Définition</p>
                    <div className="mt-[10px] text-sm font-Poppins-Regular">Correspond à la quantité définie par l'unité indiqué sur la tableau.</div>
                  </div>
                </>
              );
            case "impact_percent":
              return (
                <>
                  <div className="h-[70px] w-[600px] mx-[30px] border-[#BEC4CA] border-b-[2px] flex justify-between items-center">
                    <div className="h-[70px] w-[400px] flex items-center justify-start font-Poppins-SemiBold text-lg">% d'impact</div>
                    <button
                      className="flex justify-between w-[100px]"
                      onClick={() => {
                        setDescription(0);
                      }}
                    >
                      <p className="text-gray-400 font-Poppins-SemiBold">Retour</p>
                      <BackArrow transform="rotate(180)" />
                    </button>
                  </div>
                  <div className="w-[600px] mx-[30px] my-[10px]">
                    <p className="font-Poppins-SemiBold">Définition</p>
                    <div className="mt-[10px] text-sm font-Poppins-Regular">Correspond au pourcentage d'impact du score total.</div>
                  </div>
                </>
              );

            case "validate":
              return (
                <>
                  <div className="h-[70px] w-[600px] mx-[30px] border-[#BEC4CA] border-b-[2px] flex justify-between items-center">
                    <div className="h-[70px] w-[400px] flex items-center justify-start font-Poppins-SemiBold text-lg">Valider</div>
                    <button
                      className="flex justify-between w-[100px]"
                      onClick={() => {
                        setDescription(0);
                      }}
                    >
                      <p className="text-gray-400 font-Poppins-SemiBold">Retour</p>
                      <BackArrow transform="rotate(180)" />
                    </button>
                  </div>
                  <div className="w-[600px] mx-[30px] my-[10px]">
                    <p className="font-Poppins-SemiBold">Définition</p>
                    <div className="mt-[10px] text-sm font-Poppins-Regular">Indique que le remplissage des informations d'un processus donné ont été complété.</div>
                  </div>
                </>
              );

            default:
              return (
                <>
                  <div className="h-[70px] w-[600px] mx-[30px] border-[#BEC4CA] border-b-[2px] flex justify-between items-center">
                    <div className="h-[70px] w-[400px] flex items-center justify-start font-Poppins-SemiBold text-lg">{impact_indicators.find((x) => x.id === description).name.fr}</div>
                    <button
                      className="flex justify-between w-[100px]"
                      onClick={() => {
                        setDescription(0);
                      }}
                    >
                      <p className="text-gray-400 font-Poppins-SemiBold">Retour</p>
                      <BackArrow transform="rotate(180)" />
                    </button>
                  </div>
                  <div className="w-[600px] mx-[30px] my-[10px]">
                    <p className="font-Poppins-SemiBold">Définition</p>
                    <div className="mt-[10px] text-sm font-Poppins-Regular">{impact_indicators.find((x) => x.id === description).description}</div>
                  </div>

                  {/* DELETE */}
                  <div className="w-full flex justify-center relative">
                    <button
                      className="font-Poppins-SemiBold text-mainGreen"
                      onClick={() => {
                        // let tempArray = [...columns];
                        // let newArray = [...columns];
                        toast.warning(
                          <div className="flex justify-between items-center">
                            <p>Supression de l'indicateur {impact_indicators.find((current) => current.id === description).name}</p>
                            {/* <button
                              className="bg-mainGreen py-[5px] px-[10px] text-sm text-white rounded-lg"
                              onClick={() => {
                                setColumns(columns);
                              }}
                            >
                              Annuler
                            </button> */}
                          </div>
                        );
                        // newArray.splice(description - 1, 1);

                        setColumns(columns.filter((x) => x !== description));
                        setDescription(0);
                      }}
                    >
                      Supprimer
                    </button>
                  </div>
                </>
              );
          }
        })()}

        {/* <div className="h-[70px] w-[600px] mx-[30px] border-[#BEC4CA] border-b-[2px] flex justify-between items-center">
          <div className="h-[70px] w-[400px] flex items-center justify-start font-Poppins-SemiBold text-lg">{impact_indicators.find((current) => current.id === columns[description - 1]).name}</div>
          <button
            className="flex justify-between w-[100px]"
            onClick={() => {
              setDescription(0);
            }}
          >
            <p className="text-gray-400 font-Poppins-SemiBold">Retour</p>
            <BackArrow transform="rotate(180)" />
          </button>
        </div> */}

        {/* DESCRIPTION */}
        {/* <div className="w-[600px] mx-[30px] my-[10px]">
          <p className="font-Poppins-SemiBold">Définition</p>
          <div className="mt-[10px] text-sm font-Poppins-Regular">{impact_indicators.find((current) => current.id === columns[description - 1]).description}</div>
        </div> */}
      </div>
    </>
  );
};

export default ColumnDescrition;
